export default class Nav {

    /** contient le valeur de la position précédente */
    static prevPosition;

    constructor() {
        Nav.menu();
        if (window.matchMedia("(min-width: 1000px)").matches) {
            Nav.hoverMenu();
            //Nav.stickyMenu();
            Nav.onDesktopScroll();
        } else {
            Nav.menuMobileTools();
            Nav.openMenuMobile();
            Nav.onMobileScroll();
        }
    }

    /**
     * --------------
     * menu
     * --------------
     * gère le menu
     */
    static menu() {
        const trigger = '[data-trigger="wpiris-menu-toggle"]',
            elementItem = '.menu-item-has-children';

        $(elementItem).append('<span class="moreMenu"></span>');
        $(document).on('click', trigger, function (e) {
            e.preventDefault();
            $(trigger).toggleClass('open');
            $('body').toggleClass('menuOpen');
        });
    }

    /**
     * ---------------
     * menuMobileTools
     * ---------------
     * @description
     * Ajoute les tools au menu mobile
     */
    static menuMobileTools() {
        const tools = $('[data-menu-tools]').first();
        tools.appendTo('[data-mainnav]');
    }

    /**
     * ---------------
     * stickyMenu
     * ---------------
     * @description
     * au scroll, fait apparaître le menu en sticky
     */
    static stickyMenu() {
        $(window).on('scroll', function () {
            const scrollPosition = $(this).scrollTop();

            if( Theme.page_list.CURRENT_PAGE === Theme.page_list.PAGE_HOME ) {
                if (scrollPosition > 200) {
                    if (!$('.menu-home-sticky').hasClass('active')) {
                        $('.menu-home-sticky').addClass('active');
                    }
                } else {
                    $('.menu-home-sticky').removeClass('active');
                }
            } else {
                if (scrollPosition > 100) {
                    if (!$('.navbar').hasClass('navbar--sticky')) {
                        $('.navbar').addClass('navbar--sticky');
                        $('.logo .logoItem img').attr('src', Theme.themeURL + '/assets/dist/images/interface/logo-sticky-menu.svg');
                        $('.logo .logoItem img').addClass('sticky');
                    }
                } else {
                    $('.navbar').removeClass('navbar--sticky');
                    $('.logo .logoItem img').attr('src', Theme.themeURL + '/assets/dist/images/logo.svg');
                    $('.logo .logoItem img').removeClass('sticky');
                }
            }
        });
    }

    /**
     * --------------
     * hoverMenu
     * --------------
     * @description
     * gère les hover sur le menu
     */
    static hoverMenu() {
        const items = $('.mainnav .menu > .menu-item');
        const tools = $('[data-tools-item]');

        // nav
        $(items).on('mouseenter', function () {
            $(items).addClass('opacity');
            $(tools).addClass('opacity');
            $(this).removeClass('opacity');
        });

        $(items).on('mouseleave', function () {
            $(items).removeClass('opacity');
            $(tools).removeClass('opacity');
        });

        // tools
        $(tools).on('mouseenter', function () {
            $(tools).addClass('opacity');
            $(items).addClass('opacity');
            $(this).removeClass('opacity');
        });

        $(tools).on('mouseleave', function () {
            $(tools).removeClass('opacity');
            $(items).removeClass('opacity');
        });
    }

    /**
     * ----------------
     * openMenuMobile
     * ----------------
     * @description
     * Ouvre/ferme un sous menu
     */
    static openMenuMobile = function() {
        $( document ).on( 'click', '.moreMenu', function() {
            $( this ).toggleClass('active');
            $( this ).prev('.sub-menu').toggleClass('active');
        } );
    }

    /**
     * ----------------
     * onMobileScroll
     * ----------------
     * @description
     * Fait apparaître le menu burger au scroll
     */
    static onMobileScroll = function() {
        $( window ).on('scroll', function() {
            const currentPosition = $( window ).scrollTop();

            if( currentPosition > 500 ) {
                if( !$( '.burgerItem' ).hasClass('fixed') ) {
                    $( '.burgerItem' ).addClass('fixed');
                    $( '.burgerItem' ).css({opacity: 0});
                }

                if( currentPosition > Nav.prevPosition + 10 ) {
                    // on descend
                    if( !$( '.burgerItem' ).hasClass('open') ) {
                        $( '.burgerItem' ).addClass('invisible');
                    }
                    Nav.prevPosition = currentPosition;
                } else if( currentPosition < Nav.prevPosition - 5 ) {
                    // on monte
                    $( '.burgerItem' ).removeClass('invisible');
                    $( '.burgerItem' ).addClass('visible');
                    Nav.prevPosition = currentPosition;
                }
            } else {
                if( $( '.burgerItem' ).hasClass('fixed') ) {
                    $( '.burgerItem' ).removeClass('fixed');
                    $( '.burgerItem' ).removeClass('visible');
                    $( '.burgerItem' ).css({opacity: 1});
                    Nav.prevPosition = currentPosition;
                }
            }
            Nav.prevPosition = currentPosition;
        })
    }

    /**
     * ----------------
     * onDesktopScroll
     * ----------------
     * @description
     * Fait apparaître le menu au scroll
     */
    static onDesktopScroll = function() {
        $( window ).on('scroll', function() {
            const currentPosition = $( window ).scrollTop();

            if( currentPosition > 500 ) {
                if( !$( '.navbar, .menu-home-sticky' ).hasClass('navbar--sticky') ) {
                    $( '.navbar, .menu-home-sticky' ).addClass('navbar--sticky');
                    $( '.navbar, .menu-home-sticky' ).css({opacity: 0});

                    $('.logo .logoItem img').attr('src', Theme.themeURL + '/assets/dist/images/interface/logo-sticky-menu.svg');
                    $('.logo .logoItem img').addClass('sticky');
                }

                if( currentPosition > Nav.prevPosition + 10 ) {
                    // on descend
                    $( '.navbar, .menu-home-sticky' ).addClass('invisible');
                    Nav.prevPosition = currentPosition;
                } else if( currentPosition < Nav.prevPosition - 5 ) {
                    // on monte
                    $( '.navbar, .menu-home-sticky' ).removeClass('invisible');
                    $( '.navbar, .menu-home-sticky' ).addClass('visible');
                    Nav.prevPosition = currentPosition;
                }
            } else {
                if( $( '.navbar, .menu-home-sticky' ).hasClass('navbar--sticky') ) {
                    $( '.navbar, .menu-home-sticky' ).removeClass('navbar--sticky');
                    $( '.navbar, .menu-home-sticky' ).removeClass('invisible');
                    $( '.navbar, .menu-home-sticky' ).removeClass('visible');
                    $( '.navbar, .menu-home-sticky' ).css({opacity: 1});

                    $('.logo .logoItem img').attr('src', Theme.themeURL + '/assets/dist/images/logo.svg');
                    $('.logo .logoItem img').removeClass('sticky');
                    Nav.prevPosition = currentPosition;
                }
            }
            Nav.prevPosition = currentPosition;
        })
    }
}